import { Controller } from '@hotwired/stimulus'

// Mobile burger toggle for the back-office sidebar. Below the xl breakpoint the
// sidebar sits off-canvas (-translate-x-full); the page-header burger slides it in
// and reveals a backdrop, which (or the Escape key) slides it back out. At xl and
// up the sidebar is permanently visible, so opening/closing is a visual no-op.
export default class extends Controller {
  static targets = ['menu', 'backdrop', 'button']

  open() {
    this.#setOpen(true)
  }

  close() {
    this.#setOpen(false)
  }

  #setOpen(open) {
    this.menuTarget.classList.toggle('-translate-x-full', !open)
    this.menuTarget.classList.toggle('translate-x-0', open)
    this.backdropTarget.classList.toggle('hidden', !open)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', open.toString())
    }
  }
}
